import { ReactElement } from 'react';

import { ICD9Procedure } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { FormContextValues } from '@dreryk/react-common';

import { dischargeSummaryTranslationKeys } from '../../../../translations';

import { StyledProcedureField } from './ProcedureField.styled';

type ProcedureFieldFormBeanPart = {
   procedurePerformed: ICD9Procedure | null;
};

type ProcedureSelectorProps = Pick<FormContextValues<ProcedureFieldFormBeanPart>, 'register'> & {
   readonly dictionaryValidOn: Date;
};

export const ProcedureField = (props: ProcedureSelectorProps): ReactElement => {
   return (
      <StyledProcedureField
         label={dischargeSummaryTranslationKeys.procedurePerformed}
         dictionaryValidOn={props.dictionaryValidOn}
         register={props.register}
         validationRules={{ required: true }}
         name={'procedurePerformed'}
         testId={'procedurePerformed'}
      />
   );
};
